export default __webpack_public_path__ + "static/media/ashe_coxon.f131d776.jpg";